import axios from "axios";
import { API } from "../../backend";
import authHeader from "../auth-header"
const addRatecard = ( cardname,effectiveform,effectiveto,rowData) => {
  return axios.post(API + "inventory/create/ratecard/", {
    cardname,
    effectiveform,
    effectiveto,
    rowData,
  },{headers: authHeader(),});
};
const editRatecard = ( state,cardname,effectiveform,effectiveto,rowData) => {
  return axios.post(API + "inventory/edit/ratecard/"+state+"/", {
    cardname,
    effectiveform,
    effectiveto,
    rowData,
  },{headers: authHeader(),});
};
const getratecard = (state)=>{
  return axios.get(API + "inventory/edit/ratecard/"+state+"/",{headers: authHeader()} ) 
}
const AddRatecardService = {
    addRatecard,
    editRatecard,
    getratecard
  };
  export default AddRatecardService;